import { Component, OnInit, Input, NgZone,ViewChild } from '@angular/core';
import { TablaMisIniciativas, Iniciativa, PriorizacionArea,PriorizacionGral, PriorizacionSubsecretario } from 'src/app/interfaces/interfaces';
import { DataService } from 'src/app/services/data.service';
import { NotifierService } from 'angular-notifier';
import { PaginadoAdiminstrador, Paginado} from 'src/app/models/paginado';
import {CdkDragDrop, moveItemInArray,CdkDropList, transferArrayItem} from '@angular/cdk/drag-drop';
import {MatTable} from '@angular/material/table';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';




@Component({
  selector: 'app-modal-priorizacion',
  templateUrl: './modal-priorizacion.component.html',
  styleUrls: ['./modal-priorizacion.component.css']
})

export class ModalPriorizacionComponent implements OnInit {
  @ViewChild('table1') table1: MatTable<any>;
  @ViewChild('table2') table2: MatTable<any>;
  @ViewChild('list1') list1: CdkDropList;
  
  tablaPriorizacion: TablaMisIniciativas[] = [];
  tablaOrdenada:PriorizacionArea[]=[];
  tabla:PriorizacionArea[]=[];
  tablaGral:PriorizacionGral[]=[];
  tablaSubse:PriorizacionSubsecretario[]=[];
  idRolSeleccionado:number;
  // Loading
  loadingFiltro: boolean = true;
  loadingGeneral: boolean = true;
  // Animacion tabla
  pulseAnimacion: string;
  // Cuenta usuario
  @Input() emailUser: string;
  @Input() modoLider: boolean;
  @Input() modoAdmin: boolean;
  filtrado = false;
  
  @ViewChild('table') table: MatTable<Iniciativa>;
  @ViewChild('list') list: CdkDropList;
  displayedColumns: string[] = ['position', 'Folio', 'Sistema', 'Tipo','Solicitante','Fecha','Estatus'];
  dataSource:any;
  paginado: PaginadoAdiminstrador;
  loading:boolean=false;
  esPeriodo: boolean;
  paginaActualPaginado: Paginado;


  constructor(private dataService: DataService,
    private notifier: NotifierService,
    private zone: NgZone,
    private router: Router,
    private authService: AuthService) 
    {
      //this.emailUser=datos['tabla'];
    }

  ngOnInit(): void {
    
    //Nos subscribimos al método para el rol seleccionado
    this.authService.escuchaRolSeleccionado().subscribe((res) => {
      this.idRolSeleccionado = res;
    });
    //Verificamos si es periodo de priorizacion
    this.dataService.getPeriodoPriorizacion(this.idRolSeleccionado).subscribe(
      data=>{
        this.esPeriodo=data['objData'];
      }
    );

    this.authService.user.subscribe((user: string) => {
      {this.emailUser = user}
      //return this.emailUser;

      this.paginado = new PaginadoAdiminstrador();
      this.paginado.orderByGeneral=false;
      this.paginado.numeroPagina = 1;
      this.paginado.opcion = 1;
      this.paginado.email=this.emailUser;
      this.verDetallesIniciativa(this.paginado)
    });

  }
  
  dropTable(event: CdkDragDrop<PriorizacionArea[]>) 
  {
    const prevIndex = this.tablaPriorizacion.findIndex((d) => d === event.item.data);
    moveItemInArray(this.tablaPriorizacion, event.previousIndex, event.currentIndex);
    //prevIndex
    //this.table.renderRows();
    this.tablaOrdenada=event.container.data;
    /*this.dataSource.forEach((value, index) => {
      let v={
        'id_iniciativa':value['id_iniciativa'],
        'priorizacion_gralIniciativa':value['priorizacion_gralIniciativa'],
        'priorizacion_subSecIniciativa':value['priorizacion_subSecIniciativa'],
        'priorizacion_areaIniciativa':index+1
      }
      this.tabla.push(v);
    });*/
  }
  
  
  verDetallesIniciativa(paginado:PaginadoAdiminstrador) 
  {
    this.dataService.obtenerIniciativasPriorizacion(paginado.email,this.idRolSeleccionado,paginado.orderByGeneral).subscribe(
      data => {
        this.tablaPriorizacion=data['data'];
        this.dataSource = data['data'];
        this.loading=false;
      },
      error => {
        this.notifier.notify(
          'error',
          'Error al intentar obtener la información de la iniciativa. Verifica tu conexión de red.'
        );
      }
    );
  }

  //Método para guardar la priorización del direcctor de área
  guardarPriorizacionArea()
  {
    //this.loading=true;
     this.tablaOrdenada.forEach((value, index) => {
      let json={
        'id_iniciativa':value['id_iniciativa'],
        'priorizacion_areaIniciativa':index+1,
        'id_estatusIniciativa':value['id_estatusIniciativa']

      }
       this.tabla.push(json);
    });
    
    var myJSON = JSON.stringify(this.tabla);

    let valores={
      'userlogin':this.emailUser,
      'json_priorización':myJSON,
    }
    //Enviamos los valores para priorizar
    this.dataService.envioPriorizacionArea(valores).subscribe(
      data => {
        if (data['errorMessage']) 
        {
          this.loading=false
          this.notifier.notify('error',data['errorMessage']);
          //this.zone.run(() => this.router.navigate(['/iniciativas']));
          //this.notifier.notify('error', 'No se han podido priorizar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.')
        } else {
          this.notifier.notify('success', 'Priorización registrada correctamente.');
           this.zone.run(() => this.router.navigate(['/iniciativas']));
           //this.verDetallesIniciativa(this.paginado);
          //this.loading=false
        }
      }
    );
  }

  //Método para guardar la priorización del direcctor gral.
  guardarPriorizacionGral()
  {
    //this.loading=true;
     this.tablaOrdenada.forEach((value, index) => {
      let json={
        'id_iniciativa':value['id_iniciativa'],
        'priorizacion_gralIniciativa':index+1,
        'id_estatusIniciativa':value['id_estatusIniciativa']
      }
       this.tablaGral.push(json);
    });
    
    var myJSON = JSON.stringify(this.tablaGral);

    let valores={
      'userlogin':this.emailUser,
      'json_priorización':myJSON
    }
    //Enviamos los valores para priorizar
    this.dataService.envioPriorizacionGral(valores).subscribe(
      data => {
        if (data['errorMessage']) 
        {
          this.loading=false
          this.notifier.notify('error',data['errorMessage']);
          //this.notifier.notify('error', 'No se han podido priorizar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.')
        } else {
          this.notifier.notify('success', 'Priorización registrada correctamente.');
          this.zone.run(() => this.router.navigate(['/iniciativas']));
          //this.verDetallesIniciativa(this.paginado);
          //this.loading=false
        }
      }
    );
  }

  //Método para guardar la priorización del direcctor de área
  guardarPriorizacionSubse()
  {

    if(this.tablaOrdenada.length > 0 )
    {
      this.tablaOrdenada.forEach((value, index) => {
        let json={
          'id_iniciativa':value['id_iniciativa'],
          'priorizacion_subSecIniciativa':index+1,
          'id_estatusIniciativa':value['id_estatusIniciativa']
        }
         this.tablaSubse.push(json);
      });
      var myJSON = JSON.stringify(this.tablaSubse);

    }
    else{
      //si se ordeno respecto a la UR
      if(this.paginado.orderByGeneral==true)
      {
        this.tablaPriorizacion.forEach((value, index) => {
          let json={
            'id_iniciativa':value['id_iniciativa'],
            'priorizacion_subSecIniciativa':value['priorizacion_gralIniciativa'],
            'id_estatusIniciativa':value['id_estatusIniciativa']
          }
           this.tablaSubse.push(json);
        });
        var myJSON = JSON.stringify(this.tablaSubse);
      }else{
        this.tablaOrdenada.forEach((value, index) => {
          let json={
            'id_iniciativa':value['id_iniciativa'],
            'priorizacion_subSecIniciativa':index+1,
            'id_estatusIniciativa':value['id_estatusIniciativa']
          }
           this.tablaSubse.push(json);
        });
        var myJSON = JSON.stringify(this.tablaSubse);
      }
    }
      
    //this.loading=true;
    let valores={
      'userlogin':this.emailUser,
      'json_priorización':myJSON
    }
    //Enviamos los valores para priorizar
    this.dataService.envioPriorizacionSubsecretario(valores).subscribe(
      data => {
        if (data['errorMessage']) 
        {
          this.loading=false
          this.notifier.notify('error',data['errorMessage']);
          //this.notifier.notify('error', 'No se han podido priorizar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.')
        } else {
          this.notifier.notify('success', 'Priorización registrada correctamente.');
          this.zone.run(() => this.router.navigate(['/iniciativas']));
          //this.verDetallesIniciativa(this.paginado);
          //this.loading=false
        }
      }
    );
  }

  
cerrar(){
  this.zone.run(() => this.router.navigate(['/iniciativas']));
}

descargarExcelPriorizacion(){
  let valores={
    'email':this.emailUser,
    'rolUserlogin':this.idRolSeleccionado
  }
  this.dataService.descargarExcelPriorizacion(valores).subscribe(res => {
    let newBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob);
      return;
    }
    const data = window.URL.createObjectURL(newBlob);

   let link = document.createElement('a');
   link.href = data;
   link.download = "Iniciativas para priorización";
   link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

  setTimeout(function () {
    // Para Firefox es necesario retrasar la revocacion del objeto ObjectURL
    window.URL.revokeObjectURL(data);
    link.remove();
  }, 100);
});


}

//Metodo para ordenar por director de area
sortingDirGral()
{
  this.loading=true;
  if(this.paginado.orderByGeneral==false){
    this.paginado.orderByGeneral=true;
  }
  else{
    this.paginado.orderByGeneral=false;
  }
  this.verDetallesIniciativa(this.paginado);
  //this.loading=false;

}


}
